var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaveSupplier',{attrs:{"supplierDetail":_vm.supplierDetail},on:{"saveDetail":_vm.saveSupplier,"cancelCreate":_vm.cancelCreate}})
}
var staticRenderFns = []

export { render, staticRenderFns }